import { Doctor } from '../store/types/prescription';
import { GET_REFERRAL_RECEIVED_BY_DOC_ID } from './constants';
import { CreateReferalData } from './createReferal';
import fetchWithRefresh from './fetchWithRefresh';

export type CreateReferalReceivedData = CreateReferalData & { referral_given_doc_profile: Doctor };

export interface Response {
    success: boolean;
    referData: CreateReferalReceivedData[];
}

export default (): Promise<Response> => {
    return fetchWithRefresh(GET_REFERRAL_RECEIVED_BY_DOC_ID).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to getReferralReceivedDataByDocId');
        }
    });
};
